export default __webpack_public_path__ + "29a6dfadc43f8ee3f6992554202e854f.png";